<template>
  <b-row>
    <b-col lg="12">
      <b-card header="Historial">

        <div class="form-group form-inline pull-left">
          <input v-model="search" type="search" class="form-control" placeholder="Buscar"> &nbsp;
        </div>
        <div class="form-group form-inline pull-right">
          <date-picker v-model="date.start" lang="es" type="date" required format="DD/MM/YYYY"></date-picker>&nbsp;
          <date-picker v-model="date.end" lang="es" type="date" required format="DD/MM/YYYY"></date-picker>&nbsp;
          <button @click="getRqs()" type="button" class="btn btn-primary">Buscar</button>&nbsp;
          <download-excel
            class="btn btn-primary"
            :data="filteredRqs"
            :fields="json_fields"
            name="servicios_finalizados.xls"
          >Descargar Excel
          </download-excel>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
            <tr>
              <th>Comprobante EIR (impo)</th>
              <th>Número EIR (impo)</th>
              <th>Operación</th>
              <th>Referencia cliente</th>
              <th>Nº BL/Booking</th>
              <th>Nº Contenedor</th>
              <th>Transporte</th>
              <th>Nº Placa</th>
              <th>Conductor</th>
              <th>Número de teléfono</th>
              <th>Fecha - Hora Cita</th>
              <th>Terminal Retiro</th>
              <th>Terminal Devolución</th>
              <th>Hora de inicio de recorrido (FULL)</th>
              <th>Hora de llegada al CLIENTE</th>
              <th>Inicio de Carga</th>
              <th>Término de Carga</th>
              <th>Inicio de Descarga</th>
              <th>Término de Descarga</th>
              <th>Hora de Salida del CLIENTE</th>
              <th>Tiempo en último status (min)</th>
              <th>Hora llegada al terminal Full</th>
              <th>Precinto de Aduana</th>
              <th>Precinto de Linea</th>
              <th>Tara</th>
              <th>Dirección del cliente</th>
              <!-- <th>Ubicación</th> -->
              <th>Estado</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(rq,k) in paginated('filteredRqs')" @contextmenu.prevent="selectRq(rq)" :key="k">
              <td>
                <button
                  @click="openModalEir(rq.doc_eir)"
                  type="button"
                  class="btn btn-primary"
                  data-toggle="modal"
                  data-target="#exampleModal"
                  v-if="rq.doc_eir"
                >
                  <i class="fa fa-camera"></i>
                </button>
              </td>
              <td>{{rq.number_eir ? rq.number_eir : '--'}}</td>
              <td>{{rq.service ? rq.service.service_type.name : ''}}</td>
              <td>{{rq.service ? rq.service.reference : ''}}</td>
              <td>{{rq.service ? rq.service.doc_number : ''}}</td>
              <td>{{rq.container_number ? rq.container_number : ''}}</td>
              <td>{{rq.truck ? rq.truck.provider.name : ''}}</td>
              <td>{{rq.truck ? rq.truck.plate : ''}}</td>
              <td>{{rq.driver ? `${rq.driver.last_name} ${rq.driver.name}` : '' }}</td>
              <td>{{rq.truck ? rq.truck.mobile : ''}}</td>
              <td>{{rq.date}}</td>
              <td>{{rq.deposit_pick ? rq.deposit_pick.name : '-'}}</td>
              <template v-if="rq.service.service_type.code === 'IMPO' && rq.deposit">
                <td>{{rq.deposit.name}}</td>
              </template>
              <template v-else>
                <td>-</td>
              </template>
              <td>{{rq.start_full}}</td>
              <td>{{rq.arrival}}</td>
              <td>{{rq.start_charge}}</td>
              <td>{{rq.end_charge}}</td>
              <td>{{rq.start_discharge}}</td>
              <td>{{rq.end_discharge}}</td>
              <td>{{rq.departure}}</td>
              <td>{{rq.lastStatus}}</td>
              <td>{{rq.arrival_terminal_full}}</td>
              <td>{{rq.seal_customs}}</td>
              <td>{{rq.seal_line}}</td>
              <td>{{rq.seal_tare}}</td>
              <td>{{rq.address ? rq.address.alias: '-'}} - {{rq.address ? rq.address.place.name : '-'}}</td>
              <!-- <template v-if="rq.truck">
                <td><a type="button"
                       v-bind:href="'https://www.google.com/maps/search/?api=1&query='+rq.truck.lat+','+rq.truck.lng+''">Ver
                  en mapa</a>
                </td>
              </template>
              <template v-else>
                <td>-</td>
              </template> -->
              <td>{{rq.status ? rq.status.name : '-'}}</td>
            </tr>
            </tbody>
          </table>

          <paginate name="filteredRqs" :list="filteredRqs" class="paginate-list" :per="10"></paginate>
          <paginate-links
            for="filteredRqs"
            :limit="5"
            :show-step-links="true"
            :step-links="{
                next: '>>',
                prev: '<<'
              }"
            :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
          ></paginate-links>
          <context-menu id="context-menu" ref="ctxMenu">
            <li @click="Detail()" class="ctx-item">Ver detalle</li>
          </context-menu>
        </div>

        <ModalEIR :showModalEir="showModalEir" :doc_eir="doc_eir" @close="closeModalEir()"/>
        <div v-if="showModalEir" class="modal-backdrop fade show"></div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import api from "@/helpers/api";
  import s3 from '@/helpers/aws'
  import constants from "@/constants";
  import moment from 'moment';
  import ModalEIR from "./ModalEir";
  import finish from '@/helpers/json_fields/finish'

  export default {
    components: {ModalEIR},
    data() {
      return {
        rqs: [],
        paginate: ["filteredRqs"],
        search: "",
        showModalEir: false,
        doc_eir: "",
        constants: {},
        date: {
          start: moment().format('YYYY-MM-DD 00:00:00'),
          end: moment().format('YYYY-MM-DD 00:00:00'),
        },
        json_fields: finish
      };
    },
    computed: {
      filteredRqs() {
        return this.rqs.filter(rq => {
          let condition = true
          if (this.search) {
            condition = (rq.service.doc_number && rq.service.doc_number.toLowerCase().includes(this.search.toLowerCase())) ||
              (rq.container_number && rq.container_number.toLowerCase().includes(this.search.toLowerCase()))
          }
          return condition;
        });
      }
    },
    mounted() {
      this.getRqs();
    },
    methods: {
      getRqs() {

        this.constants = constants;
        let data = {
          status_code: [constants.FINALIZADO, constants.ANULADO_TRAMARSA],
          start_date: moment(this.date.start).format('YYYY-MM-DD 00:00:00'),
          end_date: moment(this.date.end).format('YYYY-MM-DD 23:59:59')
        };

        api.post(`/company_requeriments`, data).then(response => {
          console.log(response.requeriments)
          this.rqs = response.requeriments;
        });
      },
      selectRq(rq) {
        this.rq = rq;
        this.$refs.ctxMenu.open();
      },
      Detail() {
        this.$router.push(`/${this.rq.service.service_type.void ? 'voids' : 'requeriments'}/${this.rq.service.service_type.url}/detail/${this.rq.id}`);
      },
      linkOriginal(rq) {
        if (rq.service.code === constants.ARRUMAJE) {
          return `[<a href='/requeriments/detail/${
            rq.requeriment_id
          }' title="Servicio principal">${rq.requeriment_id} - ${
            rq.original.service.name
          }</a>]`;
        }
      },
      closeModalEir() {
        this.showModalEir = false;
        this.doc_eir = "";
      },
      openModalEir(doc_eir) {
        const url = s3.getSignedUrl("getObject", {
          Bucket: `${process.env.VUE_APP_AWS_BUCKET}/doc_eir`,
          Key: doc_eir,
          Expires: 60
        });
        this.doc_eir = url;
        console.log(url);
        this.showModalEir = true;
      }
    }
  };
</script>
